import { PostgreSqlConfiguration } from "./PostgreSqlConfiguration.js";

export interface IntegrationConfigurations {
    postgreSql: PostgreSqlConfiguration;
}
